import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

const mySqlToLocal = date => dayjs.utc(date, "YYYY-MM-DD HH:mm:ss").local()

export default mySqlToLocal
